import { z } from 'zod';

const ImageSchema = z.object({
    id: z.string().default(''),
    name: z.string(),
    url: z.string(),
    width: z.number(),
    height: z.number(),
});

export { ImageSchema };
